import { GlobalStorage } from '@/global/storage'
import { useAppStore } from '@/stores/appStore'
import { containForbidChars } from '@/tools/string'
import { message } from 'antd'

const forbidCheckList = [
  {
    label: '名称',
    name: 'name',
  },
  {
    label: '型号',
    name: 'model',
  },
  {
    label: '税收分类名称',
    name: 'taxCategoryName',
  },
  {
    label: '税收分类编码',
    name: 'taxCategoryCode',
  },
  {
    label: '简称',
    name: 'taxCategoryAbbr',
  },
]

export function productForbidCharValidator(rule: any, value: any) {
  const productForbidChar = GlobalStorage.getStorageSync('PRODUCT_FORBID_CHAR')
  const productForbidCharList = productForbidChar.split('')
  const warningChar = productForbidCharList.join('、')
  if (productForbidChar && productForbidChar.length > 0) {
    if (containForbidChars(value, productForbidCharList).contain) {
      return Promise.reject(`无法输入系统禁止字符${warningChar}`)
    }
  }
  return Promise.resolve()
}
export function useProductForbidCharCheck() {
  const getProductForbidChar = useAppStore(
    (state) => state.getProductForbidChar,
  )

  /**
   * 传入包含指定检验值的对象
   */
  async function checkProductForbidChar(values?: any) {
    const productForbidChar = await getProductForbidChar()
    const productForbidCharList = productForbidChar.split('')
    const warningChar = productForbidCharList.join('、')
    for (const checkItem of forbidCheckList) {
      const checkResult = containForbidChars(
        (values as any)?.[checkItem.name],
        productForbidCharList,
      )
      if (checkResult.contain) {
        message.warning(`${checkItem.label}无法输入系统禁止字符${warningChar}`)
        return false
      }
    }
    return true
  }
  return {
    getProductForbidChar,
    checkProductForbidChar,
  }
}
import { GlobalStorage } from '@/global/storage'
import { useAppStore } from '@/stores/appStore'
import { containForbidChars } from '@/tools/string'
import { message } from 'antd'

const forbidCheckList = [
  {
    label: '名称',
    name: 'name',
  },
  {
    label: '型号',
    name: 'model',
  },
  {
    label: '税收分类名称',
    name: 'taxCategoryName',
  },
  {
    label: '税收分类编码',
    name: 'taxCategoryCode',
  },
  {
    label: '简称',
    name: 'taxCategoryAbbr',
  },
]

export function productForbidCharValidator(rule: any, value: any) {
  const productForbidChar = GlobalStorage.getStorageSync('PRODUCT_FORBID_CHAR')
  const productForbidCharList = productForbidChar.split('')
  const warningChar = productForbidCharList.join('、')
  if (productForbidChar && productForbidChar.length > 0) {
    if (containForbidChars(value, productForbidCharList).contain) {
      return Promise.reject(`无法输入系统禁止字符${warningChar}`)
    }
  }
  return Promise.resolve()
}
export function useProductForbidCharCheck() {
  const getProductForbidChar = useAppStore(
    (state) => state.getProductForbidChar,
  )

  /**
   * 传入包含指定检验值的对象
   */
  async function checkProductForbidChar(values?: any) {
    const productForbidChar = await getProductForbidChar()
    const productForbidCharList = productForbidChar.split('')
    const warningChar = productForbidCharList.join('、')
    for (const checkItem of forbidCheckList) {
      const checkResult = containForbidChars(
        (values as any)?.[checkItem.name],
        productForbidCharList,
      )
      if (checkResult.contain) {
        message.warning(`${checkItem.label}无法输入系统禁止字符${warningChar}`)
        return false
      }
    }
    return true
  }
  return {
    getProductForbidChar,
    checkProductForbidChar,
  }
}
